var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lineWrapper",class:'mode_' + _vm.mode},[(_vm.$slots.title)?_c('span',{staticClass:"name"},[_vm._t("title")],2):_vm._e(),(_vm.$slots.value)?_c('span',{staticClass:"value"},[_vm._t("value")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }